import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Paper,
  Card,
  CardContent,
  Grid,
  Typography,
  Button,
} from "@material-ui/core";
import externalsMaterialsActions from "../../../redux/actions/externalsMaterials";
import { AddCircleOutline as PlusIcon, Queue } from "@material-ui/icons/";
import MaterialsList from "./MaterialsList";
import Search from "./Search";
import MaterialsModal from "./MaterialsModal";

const Materials = () => {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    dispatch(externalsMaterialsActions.fetchAllMaterials());
  }, []);

  return (
    <Paper>
      <Card>
        <CardContent>
          <Grid container justify="space-between">
            <Grid item>
              <Typography variant="h4">
                <Queue style={{ fontSize: 34, marginBottom: 6 }} /> Tipos de
                Residuos
              </Typography>
            </Grid>
            <Grid item>
              <Button
                color="primary"
                variant="contained"
                startIcon={<PlusIcon />}
                size="small"
                onClick={() => setOpenModal(true)}
              >
                Solicitar Nuevo Material
              </Button>
            </Grid>
            <Grid item xs={12}>
              <hr />
            </Grid>
          </Grid>
          <Search />
          <MaterialsList />
        </CardContent>
      </Card>
      <MaterialsModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        type={"CREATE"}
      />
    </Paper>
  );
};

export default Materials;
